import { DisciplinePage } from '../../shared/components/DisciplinePage';
import { useI18n } from '../../../i18n';
import { GruposTab } from './components/GruposTab';
import { TiposTab } from './components/TiposTab';
import { FormulariosTab } from './components/FormulariosTab';
import { CadenasTab } from './components/CadenasTab';
import { AprobadoresTab } from './components/AprobadoresTab';
import { DelegacionesTab } from './components/DelegacionesTab';
import { EscaladosTab } from './components/EscaladosTab';
import { PlantillasTab } from './components/PlantillasTab';
import { InfoTooltip } from '@/components/ui/InfoTooltip';

export function RequestsAdminPage() {
  const { t } = useI18n();
  const r = t.requests;

  return (
    <div>
      <h1
        style={{
          fontSize: 18,
          fontWeight: 700,
          color: '#1F3864',
          margin: '0 0 12px 16px',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        {t.requests.adminTitle}
        <InfoTooltip
          title={t.requests.tooltips.admin.titulo}
          text={t.requests.tooltips.admin.ayuda}
        />
      </h1>
      <DisciplinePage
        accentColor="#1F3864"
        tabs={[
          { key: 'grupos', label: r.grupos, component: <GruposTab /> },
          { key: 'tipos', label: r.tipos, component: <TiposTab /> },
          {
            key: 'formularios',
            label: r.admin.formularios,
            component: <FormulariosTab />,
          },
          { key: 'cadenas', label: r.admin.cadenas, component: <CadenasTab /> },
          {
            key: 'aprobadores',
            label: r.aprobadores,
            component: <AprobadoresTab />,
          },
          {
            key: 'delegaciones',
            label: r.delegaciones,
            component: <DelegacionesTab />,
          },
          { key: 'escalados', label: r.escalados, component: <EscaladosTab /> },
          { key: 'plantillas', label: r.plantillas, component: <PlantillasTab /> },
        ]}
      />
    </div>
  );
}
